/// <reference path="filters.module.ts" />
/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Filters {

  export function meevoTimeLengthFilter(): any {
    const filter = (input: any) => {

      if (!input && _.isNumber(input) && input <= 0) {
        return "0 m";
      }

      var inputNumber = <number>input;
      var hours = ~~(inputNumber / 60);  // Floor it (~~ short hand for Math.Floor)
      var minutes = (inputNumber % 60);

      var output = (hours > 0 ? `${hours.toFixed(0)} hr ` : '') + `${(minutes > 0 ? minutes : 0).toFixed(0)} m`;

      return output.trim();
    };

    return filter;
  }

  angular.module("meevo.components.filters")
    .filter("meevoTimeLengthFilter", meevoTimeLengthFilter);
}
